import axios from '@/utils/axios';

export const paymentGateway = async () => {
  const response = await axios.get(`/payment-gateways/status`);
  return response.data.data;
};
